<template>
	<div>
		<!-- <v-radio-group v-model="selectedVal" column v-on:change="$emit('onSelected', id, selectedVal)">

               <v-radio
                color="green"
                value='2'
                label="Green"
                :readonly="disabled"
              ></v-radio>
              <v-radio
                color="amber"
                value='1'
                label="Amber"
               :readonly="disabled"
              ></v-radio>

                <v-radio
                color="red"
                value='0'
                label="Red"
                :readonly="disabled"
              ></v-radio>
            </v-radio-group> -->
	</div>
</template>

<script>
	export default {
		props: {
			id: {
				required: true
			},
			value: {},
			disabled: {
				type: Boolean
			},
			horizontal: {
				type: Boolean
			}
		},
		data() {
			return {
				selectedVal: String(this.value)
			};
		}
	};
</script>

<style scoped>
	.v-radio {
		margin-right: 12px !important;
	}
	.v-icon {
		font-size: 32px !important;
	}
	input[aria-label='Red'] ~ .v-icon {
		color: #4caf50 !important;
		caret-color: #4caf50 !important;
	}
	.v-label {
		font-size: 0.9em !important;
	}
	.v-input--radio-group--column .v-radio:not(:last-child):not(:only-child) {
		margin-bottom: 3px !important;
	}
	.v-input--selection-controls {
		margin-top: 0 !important;
	}
</style>
